import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "font-semi-bold font-size-12" }
const _hoisted_4 = { class: "row w-100" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_7 = { class: "d-flex justify-content-between" }
const _hoisted_8 = { class: "font-semi-bold font-size-12" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "row form-group" }
const _hoisted_11 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_12 = { class: "d-block mb-0 small text-muted" }
const _hoisted_13 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border"
}
const _hoisted_14 = { class: "d-block mb-0 small text-muted" }
const _hoisted_15 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_16 = { class: "d-block mb-0 small text-muted" }
const _hoisted_17 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_18 = { class: "d-block mb-0 small text-muted" }
const _hoisted_19 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_20 = { class: "d-block mb-0 small text-muted" }
const _hoisted_21 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_22 = { class: "d-block mb-0 small text-muted" }
const _hoisted_23 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_24 = { class: "d-block mb-0 small text-muted" }
const _hoisted_25 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_26 = { class: "d-block mb-0 small text-muted" }
const _hoisted_27 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_28 = { class: "d-block mb-0 small text-muted" }
const _hoisted_29 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_30 = { class: "d-block mb-0 small text-muted" }
const _hoisted_31 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_32 = { class: "d-block mb-0 small text-muted" }
const _hoisted_33 = {
  key: 2,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border"
}
const _hoisted_34 = { class: "d-block mb-0 small text-muted" }
const _hoisted_35 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_36 = { class: "d-block mb-0 small text-muted" }
const _hoisted_37 = { class: "mt-3 pl-3 pr-3 col-lg-12 col-sm-12 col-xs-12" }
const _hoisted_38 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_39 = { class: "d-flex justify-content-between" }
const _hoisted_40 = { class: "font-semi-bold font-size-12" }
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = { class: "row form-group" }
const _hoisted_43 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_44 = { class: "d-block mb-0 small text-muted" }
const _hoisted_45 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_46 = { class: "d-block mb-0 small text-muted" }
const _hoisted_47 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_firstName"
}
const _hoisted_48 = { class: "d-block mb-0 small text-muted" }
const _hoisted_49 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-9" }
const _hoisted_52 = { class: "d-block mb-0 small text-muted" }
const _hoisted_53 = { class: "col-3" }
const _hoisted_54 = { class: "d-block mb-0 small text-muted" }
const _hoisted_55 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_56 = { class: "d-block mb-0 small text-muted" }
const _hoisted_57 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_58 = { class: "d-block mb-0 small text-muted" }
const _hoisted_59 = {
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
  id: "demand_edit_identity_manager_relationType"
}
const _hoisted_60 = { class: "d-block mb-0 small text-muted" }
const _hoisted_61 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_62 = { class: "d-block mb-0 small text-muted" }
const _hoisted_63 = {
  key: 0,
  class: "col-lg-3 col-md-6 col-sm-12 form-control no-border"
}
const _hoisted_64 = { class: "d-block mb-0 small text-muted" }
const _hoisted_65 = { class: "col-lg-3 col-md-6 col-sm-12 form-control no-border" }
const _hoisted_66 = { class: "d-block mb-0 small text-muted" }
const _hoisted_67 = { class: "col-12" }
const _hoisted_68 = { class: "card-title flex-grow-1 justify-content-between align-items-center mb-0" }
const _hoisted_69 = { class: "d-flex align-items-center" }
const _hoisted_70 = { class: "font-semi-bold font-size-12" }
const _hoisted_71 = { class: "card-body" }
const _hoisted_72 = { class: "form-row" }
const _hoisted_73 = ["id"]
const _hoisted_74 = { class: "d-block mb-2 small text-muted" }
const _hoisted_75 = ["id"]
const _hoisted_76 = { class: "d-block mb-2 small text-muted" }
const _hoisted_77 = ["id"]
const _hoisted_78 = { class: "d-block mb-2 small text-muted" }
const _hoisted_79 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_80 = ["id"]
const _hoisted_81 = { class: "d-block mb-2 small text-muted" }
const _hoisted_82 = ["id"]
const _hoisted_83 = { class: "d-block mb-2 small text-muted" }
const _hoisted_84 = ["id"]
const _hoisted_85 = { class: "d-block mb-2 small text-muted" }
const _hoisted_86 = ["id"]
const _hoisted_87 = { class: "d-block mb-2 small text-muted" }
const _hoisted_88 = ["id"]
const _hoisted_89 = { class: "d-flex align-items-center mt-0" }
const _hoisted_90 = {
  key: 0,
  class: "d-block mb-2 small text-muted"
}
const _hoisted_91 = { class: "d-flex align-items-center mt-0" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { class: "col-12" }
const _hoisted_94 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_PartyContact = _resolveComponent("PartyContact")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_twCurrencyInput = _resolveComponent("twCurrencyInput")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_PartyFinancialSituation = _resolveComponent("PartyFinancialSituation")!
  const _component_TaskPartyClassification = _resolveComponent("TaskPartyClassification")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, {
    "switch-toggle-side": "",
    "header-class": "card-header expandable-items-bg-secondary no-border p-4",
    class: _normalizeClass(["card tw-items-dashed-group-secondary tw-items-group-with-bg tw-level-two-group bg-brown-1", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
    modelValue: _ctx.managedOrganizationOpened,
    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.managedOrganizationOpened) = $event))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("demand.party.roles.SG")), 1)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_q_expansion_item, {
            "switch-toggle-side": "",
            "header-class": "card-header bg-transparent no-border p-4",
            class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group m-3", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
            modelValue: _ctx.identityOpened,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.identityOpened) = $event))
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("main.labels.identity").toUpperCase()), 1)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _renderSlot(_ctx.$slots, "personPhysique", {}, () => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("party.APE")), 1),
                      _createVNode(_component_q_select, {
                        "data-testid": "demand_edit_identity_Ape",
                        dense: "",
                        outlined: "",
                        "emit-value": "",
                        "map-options": "",
                        modelValue: _ctx.party.organization.activitySector.type.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.party.organization.activitySector.type.value) = $event)),
                        disable: _ctx.isMO,
                        options: _ctx.activitySector,
                        class: _normalizeClass(_ctx.isPartyOrganizationEligible.notEligible ? 'input-error' : '')
                      }, {
                        option: _withCtx((scope) => [
                          _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, {
                                    style: _normalizeStyle({
                                  color: scope.opt.flagEligible === false || scope.opt.flagEligible === 0 ? 'red' : 'inherit'
                                })
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scope.opt.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["style"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disable", "options", "class"])
                    ]),
                    (_ctx.party.organization.codeNace)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(`${_ctx.$t(
                        "middleOffice.party.organization.identity.naceCode"
                      )}`), 1),
                          _createVNode(_component_q_input, {
                            dense: "",
                            outlined: "",
                            "emit-value": "",
                            "map-options": "",
                            modelValue: _ctx.party.organization.codeNace.type.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.party.organization.codeNace.type.value) = $event)),
                            disable: _ctx.isMO
                          }, null, 8, ["modelValue", "disable"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t(
                        "middleOffice.party.organization.identity.commercialName"
                      )), 1),
                      _createVNode(_component_q_input, {
                        dense: "",
                        outlined: "",
                        modelValue: _ctx.party.organization.commercialName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.party.organization.commercialName) = $event)),
                        disable: _ctx.isMO
                      }, null, 8, ["modelValue", "disable"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("middleOffice.party.organization.identity.name")), 1),
                      _createVNode(_component_q_input, {
                        dense: "",
                        outlined: "",
                        modelValue: _ctx.party.organization.name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.party.organization.name) = $event)),
                        disable: _ctx.isMO
                      }, null, 8, ["modelValue", "disable"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("middleOffice.party.organization.identity.acronym")), 1),
                      _createVNode(_component_q_input, {
                        dense: "",
                        outlined: "",
                        modelValue: _ctx.party.organization.acronym,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.party.organization.acronym) = $event)),
                        disable: _ctx.isMO
                      }, null, 8, ["modelValue", "disable"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("demand.filtreMenu.SIREN")), 1),
                      _createVNode(_component_q_input, {
                        dense: "",
                        mask: _ctx.getSirenMask(_ctx.party?.type?.id),
                        outlined: "",
                        modelValue: _ctx.party.organization.siren,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.party.organization.siren) = $event)),
                        disable: _ctx.isMO
                      }, null, 8, ["mask", "modelValue", "disable"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t(
                        "middleOffice.party.organization.identity.legalCategory"
                      )), 1),
                      _createVNode(_component_q_select, {
                        dense: "",
                        outlined: "",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": "",
                        "hide-selected": "",
                        "fill-input": "",
                        "input-debounce": "0",
                        modelValue: _ctx.party.organization.legalCategory.type.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.party.organization.legalCategory.type.value) = $event)),
                        options: _ctx.filteredLegalCategoryOptions,
                        onFilter: _ctx.filterLegalCategory,
                        disable: _ctx.isMO
                      }, null, 8, ["modelValue", "options", "onFilter", "disable"])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("main.labels.geographicalZone")), 1),
                      _createVNode(_component_q_input, {
                        dense: "",
                        outlined: "",
                        "emit-value": "",
                        "map-options": "",
                        modelValue: _ctx.party.organization.taxGeographicZone,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.party.organization.taxGeographicZone) = $event)),
                        disable: _ctx.isMO
                      }, null, 8, ["modelValue", "disable"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t(
                        "middleOffice.party.organization.identity.commercialRegister"
                      )), 1),
                      _createVNode(_component_q_input, {
                        dense: "",
                        outlined: "",
                        modelValue: _ctx.party.organization.commercialRegister,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.party.organization.commercialRegister) = $event)),
                        disable: _ctx.isMO
                      }, null, 8, ["modelValue", "disable"])
                    ]),
                    (_ctx.party.businessData)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t(
                          "middleOffice.party.organization.identity.customerType"
                        )), 1),
                            _createVNode(_component_q_input, {
                              dense: "",
                              outlined: "",
                              modelValue: _ctx.party.businessData.customerType,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.party.businessData.customerType) = $event)),
                              disable: _ctx.isMO
                            }, null, 8, ["modelValue", "disable"])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("middleOffice.party.organization.identity.activity")), 1),
                            _createVNode(_component_q_input, {
                              dense: "",
                              outlined: "",
                              modelValue: _ctx.party.businessData.activity,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.party.businessData.activity) = $event)),
                              disable: _ctx.isMO
                            }, null, 8, ["modelValue", "disable"])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.party.organization.isCreated)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t(
                        "middleOffice.party.organization.identity.creationDate"
                      )), 1),
                          _createVNode(_component_q_input, {
                            dense: "",
                            outlined: "",
                            modelValue: _ctx.party.organization.creationDate,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.party.organization.creationDate) = $event)),
                            mask: _ctx.maskInput,
                            disable: _ctx.isMO
                          }, null, 8, ["modelValue", "mask", "disable"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("label", _hoisted_36, _toDisplayString(`${_ctx.$t("middleOffice.party.organization.identity.naceCode")}`), 1),
                      _createVNode(_component_q_select, {
                        "data-testid": "third_edit_identity_naceCode",
                        dense: "",
                        outlined: "",
                        "emit-value": "",
                        "map-options": "",
                        modelValue: _ctx.party.organization.codeNACE.type.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.party.organization.codeNACE.type.value) = $event)),
                        options: _ctx.naceOptions
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      (_ctx.manager && _ctx.manager.show)
                        ? (_openBlock(), _createBlock(_component_q_list, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_expansion_item, {
                                "switch-toggle-side": "",
                                "expand-icon-toggle": "",
                                "expand-separator": "",
                                "header-class": "card-header bg-transparent no-border p-4",
                                class: "card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group",
                                modelValue: _ctx.managerOpened,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.managerOpened) = $event))
                              }, {
                                header: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t("main.labels.manager").toUpperCase()), 1)
                                    ])
                                  ])
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("main.labels.title")), 1),
                                        _createVNode(_component_q_input, {
                                          dense: "",
                                          outlined: "",
                                          "emit-value": "",
                                          "map-options": "",
                                          style: {"margin-bottom":"20px","margin-right":"10px"},
                                          modelValue: _ctx.manager.title.type.value,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.manager.title.type.value) = $event)),
                                          disable: ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("main.labels.familyName")), 1),
                                        _createVNode(_component_q_input, {
                                          dense: "",
                                          outlined: "",
                                          modelValue: _ctx.manager.familyName,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.manager.familyName) = $event)),
                                          style: {"margin-bottom":"20px","margin-right":"10px"},
                                          disable: ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("main.labels.firstName")), 1),
                                        _createVNode(_component_q_input, {
                                          "data-testid": "demand_edit_identity_manager_firstName",
                                          dense: "",
                                          outlined: "",
                                          modelValue: _ctx.manager.firstName,
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.manager.firstName) = $event)),
                                          style: {"margin-bottom":"20px","margin-right":"10px"},
                                          disable: ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                          _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("main.labels.birthDate")), 1),
                                            _createVNode(_component_q_input, {
                                              dense: "",
                                              outlined: "",
                                              style: {"margin-right":"10px"},
                                              ref: "birthDateRef",
                                              modelValue: _ctx.manager.birthDate,
                                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.manager.birthDate) = $event)),
                                              disable: "",
                                              mask: _ctx.maskInput
                                            }, null, 8, ["modelValue", "mask"])
                                          ]),
                                          _createElementVNode("div", _hoisted_53, [
                                            _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t("main.labels.age")), 1),
                                            _createVNode(_component_q_input, {
                                              "data-testid": "demand_edit_identity_manager_age",
                                              dense: "",
                                              outlined: "",
                                              modelValue: _ctx.manager.age,
                                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.manager.age) = $event)),
                                              style: {"margin-bottom":"20px","margin-right":"10px"},
                                              suffix: " ans",
                                              readonly: ""
                                            }, null, 8, ["modelValue"])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t("main.labels.telephone")), 1),
                                        _createVNode(_component_q_input, {
                                          dense: "",
                                          outlined: "",
                                          "fill-mask": "",
                                          modelValue: 
                                _ctx.manager.contacts[0].contactMechanism.phoneNumber
                              ,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((
                                _ctx.manager.contacts[0].contactMechanism.phoneNumber
                              ) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t("main.labels.dateOfEntry")), 1),
                                        _createVNode(_component_q_input, {
                                          dense: "",
                                          outlined: "",
                                          mask: _ctx.maskInput,
                                          modelValue: _ctx.manager.validity.from,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.manager.validity.from) = $event)),
                                          disable: ""
                                        }, null, 8, ["mask", "modelValue"])
                                      ]),
                                      _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t("main.labels.relationType")), 1),
                                        _createVNode(_component_q_input, {
                                          "data-testid": "demand_edit_identity_manager_relationType",
                                          dense: "",
                                          outlined: "",
                                          "emit-value": "",
                                          "map-options": "",
                                          style: {"margin-bottom":"20px","margin-right":"10px"},
                                          modelValue: _ctx.manager.relationType.type.value,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.manager.relationType.type.value) = $event)),
                                          options: _ctx.relationTypes
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      _createElementVNode("div", _hoisted_61, [
                                        _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t("main.labels.bornCountry")), 1),
                                        _createVNode(_component_q_input, {
                                          dense: "",
                                          outlined: "",
                                          "emit-value": "",
                                          "map-options": "",
                                          modelValue: 
                                _ctx.manager.birthplace.type.config.country.id
                              ,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((
                                _ctx.manager.birthplace.type.config.country.id
                              ) = $event)),
                                          disable: ""
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      (_ctx.currentRoute === 'TaskDetail')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                            _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("main.labels.gender")), 1),
                                            _createVNode(_component_q_input, {
                                              dense: "",
                                              outlined: "",
                                              "emit-value": "",
                                              "map-options": "",
                                              modelValue: _ctx.manager.gender,
                                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.manager.gender) = $event)),
                                              disable: ""
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_65, [
                                        _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.$t("main.labels.postalCode_cityOfBirth")), 1),
                                        _createVNode(_component_q_input, {
                                          dense: "",
                                          outlined: "",
                                          "use-input": "",
                                          "hide-inputed": "",
                                          "fill-input": "",
                                          modelValue: _ctx.manager.birthplace.type,
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.manager.birthplace.type) = $event)),
                                          disable: ""
                                        }, null, 8, ["modelValue"])
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ], true)
                ])
              ])
            ]),
            _: 3
          }, 8, ["class", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createVNode(_component_PartyContact, {
            party: _ctx.party,
            tabPosition: _ctx.tabPosition,
            disable: _ctx.isMO,
            class: "m-3"
          }, null, 8, ["party", "tabPosition", "disable"])
        ]),
        _createVNode(_component_q_list, { class: "col-12" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_expansion_item, {
              "switch-toggle-side": "",
              "expand-separator": "",
              "header-class": "card-header bg-transparent no-border p-4",
              class: _normalizeClass(["card tw-items-dashed-group tw-items-group-with-bg tw-level-two-group m-3", _ctx.currentRoute === 'TaskDetail' ? 'tw-analysis-section' : '']),
              onShow: _cache[27] || (_cache[27] = ($event: any) => {
      _ctx.ExpossureBtn = !_ctx.ExpossureBtn;
      _ctx.addExpandedExpossure(_ctx.exposuresList);
    }),
              onHide: _cache[28] || (_cache[28] = ($event: any) => {
      _ctx.ExpossureBtn = !_ctx.ExpossureBtn;
      _ctx.removeExpandedItem < _ctx.financialExposures > _ctx.financialExposures;
    })
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t("middleOffice.party.organization.section.expossure").toUpperCase()), 1),
                    (_ctx.isExposureBtnDisabled || _ctx.$store.getters['authModule/hasMiddleOffice'] || !_ctx.isMO)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          "data-testid": "demand_edit_financialExposure_shareRiskPool_addButton",
                          class: "btn btn-primary btn-sm ml-3",
                          icon: "add",
                          onClickCapture: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (_ctx.addExpossure()), ["stop"])),
                          disable: _ctx.isMO
                        }, null, 8, ["disable"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_71, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exposuresList, (value, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "p-2 bg-white default-border-radius mb-3",
                      key: index
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", {
                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                            id: 'demand_edit_financialExposure_outstandingEntity_' + index
                          }, [
                            _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.Outstanding_entity")), 1),
                            _createVNode(_component_q_select, {
                              "data-testid": 'demand_edit_financialExposure_outstandingEntity_' + index,
                              dense: "",
                              outlined: "",
                              "emit-value": "",
                              "map-options": "",
                              options: _ctx.financialInstitution,
                              loading: !_ctx.financialInstitution,
                              disable: !_ctx.financialInstitution || value.isDisabled || _ctx.isMO,
                              modelValue: value.financialInstitution.value,
                              "onUpdate:modelValue": [($event: any) => ((value.financialInstitution.value) = $event), ($event: any) => (_ctx.onFinancialInstitutionChange(value, $event))]
                            }, null, 8, ["data-testid", "options", "loading", "disable", "modelValue", "onUpdate:modelValue"])
                          ], 8, _hoisted_73),
                          _createElementVNode("div", {
                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                            id: 'demand_edit_financialExposure_outstandingType_' + index
                          }, [
                            _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.Outstanding_type")), 1),
                            _createVNode(_component_q_select, {
                              "data-testid": 'demand_edit_financialExposure_outstadingType_' + index,
                              modelValue: value.outstandingType.value,
                              "onUpdate:modelValue": ($event: any) => ((value.outstandingType.value) = $event),
                              dense: "",
                              outlined: "",
                              "emit-value": "",
                              "map-options": "",
                              options: _ctx.typeOutstanding,
                              loading: !_ctx.typeOutstanding,
                              disable: !_ctx.typeOutstanding || value.isDisabled || _ctx.isMO
                            }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "options", "loading", "disable"])
                          ], 8, _hoisted_75),
                          _createElementVNode("div", {
                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                            id: 'demand_edit_financialExposure_netOutstanding_' + index
                          }, [
                            _createElementVNode("label", _hoisted_78, [
                              _createTextVNode(_toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.net_outstanding")) + " ", 1),
                              (value.financialInstitution.value === 'CF' || value.financialInstitution.value === 'AFF_LIEE')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_79, "*"))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_twCurrencyInput, {
                              "data-testid": 'demand_edit_financialExposure_netOutstanding_' + index,
                              modelValue: value.netOutstanding,
                              "onUpdate:modelValue": [($event: any) => ((value.netOutstanding) = $event), ($event: any) => (_ctx.calculateExposureGrossOutstanding(index, value.netOutstanding))],
                              disable: value.isDisabled || _ctx.isMO,
                              options: _ctx.currencyConfiguration,
                              class: _normalizeClass(
                   (value.financialInstitution.value === 'CF' || value.financialInstitution.value === 'AFF_LIEE') && 
                                 (!value.netOutstanding || value.netOutstanding === 0) ? 'input-error' : ''
                )
                            }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable", "options", "class"])
                          ], 8, _hoisted_77),
                          _createElementVNode("div", {
                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                            id: 'demand_edit_financialExposure_grossOutstanding_' + index
                          }, [
                            _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.gross_outstanding")), 1),
                            _createVNode(_component_twCurrencyInput, {
                              modelValue: value.grossOutstanding,
                              "onUpdate:modelValue": [($event: any) => ((value.grossOutstanding) = $event), ($event: any) => (_ctx.calculateExposureGrossOutstanding(index, value.netOutstanding))],
                              disable: "",
                              options: _ctx.currencyConfiguration
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                          ], 8, _hoisted_80),
                          _createElementVNode("div", {
                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                            id: 'demand_edit_financialExposure_contractReference_' + index
                          }, [
                            _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.contract_reference")), 1),
                            _createVNode(_component_q_input, {
                              "data-testid": 'demand_edit_financialExposure_contractReference_' + index,
                              dense: "",
                              outlined: "",
                              modelValue: value.contractReference,
                              "onUpdate:modelValue": ($event: any) => ((value.contractReference) = $event),
                              disable: true
                            }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue"])
                          ], 8, _hoisted_82),
                          (value.businessData && _ctx.verifyKSIOPCombination(value.financialInstitution.value, value.outstandingType.value))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                id: 'demand_edit_financialExposure_contractCassiopae_' + index
                              }, [
                                _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.contract_Cassiopae")), 1),
                                _createVNode(_component_q_input, {
                                  "data-testid": 'demand_edit_financialExposure_contractCassiopae_' + index,
                                  dense: "",
                                  outlined: "",
                                  modelValue: value.businessData.contractCassiopae,
                                  "onUpdate:modelValue": ($event: any) => ((value.businessData.contractCassiopae) = $event),
                                  disable: _ctx.isMO
                                }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                              ], 8, _hoisted_84))
                            : _createCommentVNode("", true),
                          (value.businessData && _ctx.verifyKSIOPCombination(value.financialInstitution.value, value.outstandingType.value))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "col-lg-3 col-md-6 col-sm-12 form-control no-border",
                                id: 'demand_edit_financialExposure_acteurCassiopae_' + index
                              }, [
                                _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.acteurCassiopae")), 1),
                                _createVNode(_component_q_input, {
                                  "data-testid": 'demand_edit_financialExposure_acteurCassiopae_' + index,
                                  dense: "",
                                  outlined: "",
                                  modelValue: value.businessData.acteurCassiopae,
                                  "onUpdate:modelValue": ($event: any) => ((value.businessData.acteurCassiopae) = $event),
                                  disable: !value.businessData.toSettle|| _ctx.isMO
                                }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"])
                              ], 8, _hoisted_86))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "col-lg-3 col-md-6 col-sm-12 form-control no-border d-flex flex-column",
                            id: 'demand_edit_financialExposure_toggle_' + index
                          }, [
                            _createElementVNode("div", _hoisted_89, [
                              (value.businessData)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_90, _toDisplayString(_ctx.$t("middleOffice.party.organization.exposure.to_settle")), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_91, [
                              (value.businessData)
                                ? (_openBlock(), _createBlock(_component_q_toggle, {
                                    key: 0,
                                    "data-testid": 'demand_edit_financialExposure_toggle_' + index,
                                    modelValue: value.businessData.toSettle,
                                    "onUpdate:modelValue": ($event: any) => ((value.businessData.toSettle) = $event),
                                    disable: value.isDisabled || _ctx.isMO,
                                    color: "primary",
                                    size: "md"
                                  }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "disable"]))
                                : _createCommentVNode("", true),
                              (!_ctx.isMO)
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    "data-testid": "demand_edit_financialExposure_deleteButton",
                                    outline: "",
                                    class: "btn btn-outline-danger mt-0 ml-2",
                                    icon: "delete",
                                    onClick: ($event: any) => (_ctx.removeExpanded(value))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_88)
                        ]),
                        (_ctx.verifyKSIOPCombination(value.financialInstitution.value, value.outstandingType.value))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                              (_ctx.$store.getters['authModule/hasMiddleOffice'])
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 0,
                                    class: "btn btn-primary mt-3",
                                    label: _ctx.$t('demand.button.recalculation'),
                                    icon: "calculate",
                                    onClick: ($event: any) => (_ctx.recalculateKSIOP(value, index))
                                  }, null, 8, ["label", "onClick"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_93, [
          _createVNode(_component_PartyFinancialSituation, {
            party: _ctx.party,
            class: "m-3"
          }, null, 8, ["party"])
        ]),
        _createElementVNode("div", _hoisted_94, [
          _createVNode(_component_TaskPartyClassification, {
            selectedClassifications: _ctx.party?.organization?.classifications,
            class: "m-3"
          }, null, 8, ["selectedClassifications"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["class", "modelValue"]))
}